// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f1bed5ef","404":"e6b3c0ed","787":"a7761f64"}[chunkId] + ".chunk.js";
};